export const DataHook = {
  Title: 'time-table-title',
  ColumnAction: 'time-table-column-action',
  Subtitle: 'time-table-subtitle',
  Column: 'time-table-column',
  Item: 'time-table-item',
  AddItemButton: 'time-table-add-item-button',
};

export const DataAttribute = {
  ColumnActive: `data-time-table-column-active`,
  ColumnDisabled: `data-time-table-column-disabled`,
  ColumnDroppable: `data-time-table-column-droppable`,
  ItemDraggable: `data-time-table-item-draggable`,
  ItemDisabled: `data-time-table-item-disabled`,
};
